module.exports = __webpack_public_path__ + "img/active-5.2141e40a.svg";